import { rootUrl } from '@/constants';
import axios from 'axios';

export type SubmitSetReadId = {
  user: string;
  id: string;
};

export const setReadId = async (data: SubmitSetReadId) => {
  const response = await axios.post(`${rootUrl}/psychologist/set/read/id`, {
    user: data.user,
    id: data.id,
  });

  return response.data;
};
